import { redirect as routerRedirect } from "@tanstack/react-router";


const remaining = (string, max) => (max - string.length) + " " + "characters remaining";

const redirect = {
	authenticated: ({ context }) => {
		if (context.user) throw routerRedirect({ to: "/" });
	},
	unauthenticated: ({ context, location }) => {
		if (!context.user) {
			if (location.search.sub_sk || location.search.sub_cid) sessionStorage.setItem("redirect_uri", location.href);
			throw routerRedirect({ to: "/", search: { redirect_uri: location.href } });
		};
	}
};

const safeSerialize = (obj, depth = 0, seen = new WeakSet()) => {
	if (obj == null) return obj;
	if (depth > 5) return "[Max depth]";
	if (typeof obj === "function") return `[Function ${obj.name || "anonymous"}]`;
	if (typeof obj !== "object") return obj;
	if (seen.has(obj)) return "[Circular]";
	seen.add(obj);

	if (Array.isArray(obj)) return obj.map(i => safeSerialize(i, depth + 1, seen));

	const out = {};
	for (const key of Object.keys(obj)) {
		try {
			out[key] = safeSerialize(obj[key], depth + 1, seen);
		} catch (e) {
			out[key] = `[Unserializable: ${e && e.message ? e.message : String(e)}]`;
		}
	}
	return out;
};

const serializeError = (err) => {
	if (err == null) return null;

	try {
		if (typeof err === "string" || typeof err === "number" || typeof err === "boolean") return { message: String(err), name: typeof err };

		if (err instanceof Error) {
			const out = {
				name: err.name,
				message: err.message,
				stack: err.stack
			};

			if (err.code) out.code = err.code;
			if (err.status) out.type = err.status;

			// Axios-like errors
			if (err.response) {
				if (err.response.status) out.type = err.response.status;
				out.response = safeSerialize(err.response);
			}
			if (err.request) out.request = safeSerialize(err.request);

			// copy enumerable custom props
			Object.keys(err).forEach(k => {
				if (!["name", "message", "stack", "code", "status", "response", "request"].includes(k)) {
					out[k] = safeSerialize(err[k]);
				}
			});

			return out;
		}

		// Generic object
		return safeSerialize(err);
	} catch {
		return { message: "Failed to serialize error", originalType: typeof err };
	}
};

const validation = {
	remaining,
	redirect,
	serializeError
};

export default validation;